
import { useTranslation } from 'react-i18next';

export default function Processo() {
  const { t } = useTranslation();

  const steps = [
    { number: '01', titleKey: 'processo.diagnostico', descKey: 'processo.diagnosticoDesc' },
    { number: '02', titleKey: 'processo.estrategia', descKey: 'processo.estrategiaDesc' },
    { number: '03', titleKey: 'processo.producao', descKey: 'processo.producaoDesc' },
    { number: '04', titleKey: 'processo.publicacao', descKey: 'processo.publicacaoDesc' },
    { number: '05', titleKey: 'processo.crescimento', descKey: 'processo.crescimentoDesc' },
  ];

  return (
    <section id="processo" className="py-24 lg:py-32 bg-black text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            {t('processo.titulo')}
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            {t('processo.subtitulo')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="mb-6">
                <span className="text-6xl font-bold text-white/10">{step.number}</span>
              </div>
              <h3 className="text-2xl font-bold mb-4">{t(step.titleKey)}</h3>
              <p className="text-gray-300 leading-relaxed">{t(step.descKey)}</p>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 -right-4 w-8 h-0.5 bg-white/20" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
